/* unplugin-vue-components disabled */import script from "./Gnyzzx.vue?vue&type=script&lang=ts&setup=true"
export * from "./Gnyzzx.vue?vue&type=script&lang=ts&setup=true"

import "./Gnyzzx.vue?vue&type=style&index=0&id=335cdfb1&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-335cdfb1"]])

export default __exports__